























import { mapState } from "vuex";
import Vue from "vue";
import Cookies from "@/components/basic/Cookies.vue"
export default Vue.extend({
  data() {
    return {
      isMobile: false,
      TRANSLATION_KEY: "Disclaimer",
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  methods: {
    handleDisclaimer() {
      this.$store.state.showLongDisclaimer = !this.$store.state.showLongDisclaimer;
    },

    onResize() {
      this.isMobile = window.innerWidth < 768;
    },

  },
  computed: {
    ...mapState({
      showLongDisclaimer: (state: any) => state.showLongDisclaimer,
      isDetectedMobileDevice: (state: any) => state.isDetectedMobileDevice,
    }),
  },
    components: {
      Cookies
  },
});
